import React, { Component } from 'react';
import FakeData from '../../fake-data';
import { Link } from 'react-router-dom';
import './TOURN.css';
import { ItemPicker, Modal, ComboBox, TagView } from '../../components/Common';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

export default class CreateLeague extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: FakeData.getData("yoo"),
      yoo: FakeData.getData("yoo"),
      activeState: "",
      types: ["league", "group_knockout", "knockout"],
      sports: ["Soccer"],
      league: (this.props.isSeason) ? this.props.league : { sport: "Soccer", id: null },
      isStepOne: false,
      isStepTwo: false,
      isStepThree: false,
      isStepFour: false,
      activeTab: (!this.props.isSeason) ? "one" : ((this.props.isSeason && this.props.isManage) ? "three" : "two"),
      nameError: false,
      typeError: false,
      dateError: true,
      webError: true,
      emailError: true,
      contactOtherError: true,
      contactMainError: true,
      ceoError: true,
      userError: true,
      cityError: true,
      postalError: true,
      addressError: true,
      aboutError: true,
      countryError: true
    }

    this.onTeamSelect = this.onTeamSelect.bind(this)
  }

  componentWillMount() {
    this.getDataID = setInterval(() => {
      this.getData()
    }, 50);

    this.saveDataID = setInterval(() => {
      this.saveData()
    }, 2000);
  }

  componentDidMount() {
    this.state.league.tempSeason = this.state.league.currentSeason
    this.setState({
      league: this.state.league
    });
  }

  componentWillUnmount() {
    clearInterval(this.getDataID)
    clearInterval(this.saveDataID)
  }

  getData() {
    this.setState({
      user: FakeData.getData("yoo"),
      yoo: FakeData.getData("yoo"),
      teams: FakeData.getData("all_teams")
    });
  }

  saveData() {
    FakeData.setData("league-create-state", this.state.activeState)
    FakeData.setData("league-last-saved", this.state.league)
  }

  makeid(len) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < len; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  validateStepOne() {
    if ((this.state.league.name === null) || (this.state.league.name === "")) {
      this.setState({
        nameError: true
      });

      return
    } else if ((this.state.league.type === null) || (this.state.league.type === "")) {
      this.setState({
        typeError: true
      });

      return
    } else {
      this.setState({
        nameError: false,
        typeError: false
      });

      this.setStep("four")
    }
  }

  validateStepTwo() {
    const l = this.state.league
    if (l.type !== "group_knockout") {
      if ((l.noOfTeams === null) || (l.noOfTeams <= 3)) {
        this.setState({
          noOfTeamsError: true
        });
        return
      }

      if ((l.type === "knockout") && ((l.noOfTeams === 8) || (l.noOfTeams === 16))) {
        this.setState({
          noOfTeamsError: false
        });
      } else if ((l.type === "knockout") && ((l.noOfTeams !== 8) || (l.noOfTeams !== 16))) {
        this.setState({
          noOfTeamsError: true
        });

        return
      }

      if ((l.noOfLegs === null) || (l.noOfLegs <= 0)) {
        this.setState({
          noOfLegsError: true
        });

        return
      }

      l.noOfGroups = 1
      l.noOfTeamsGroup = l.noOfTeams

      this.setState({
        noOfTeamsGroupError: false,
        noOfLegsError: false,
        noOfGroupsError: false,
        noOfTeamsError: false,
        league: l
      });

      this.genDummyTeams(this.state.league.noOfTeams, 1)
    } else {
      if ((l.noOfGroups === null) || (l.noOfGroups <= 1)) {
        this.setState({
          noOfGroupsError: true
        });

        return
      }

      if ((l.noOfTeamsGroup === null) || (l.noOfTeamsGroup <= 3)) {
        this.setState({
          noOfTeamsGroupError: true
        });

        return
      }

      if ((l.noOfLegs === null) || (l.noOfLegs <= 0)) {
        this.setState({
          noOfLegsError: true
        });

        return
      }

      let num = (l.noOfGroups * l.noOfTeamsGroup)
      l.noOfTeams = num

      this.setState({
        noOfTeamsGroupError: false,
        noOfLegsError: false,
        noOfGroupsError: false,
        noOfTeamsError: false,
        league: l
      });

      this.genDummyTeams(this.state.league.noOfTeamsGroup, this.state.league.noOfGroups)

      //this.setStep("three")
    }
  }

  setStep(key) {
    if (key === "one") {
      if (this.state.isStepOne) {
        return;
      }

      this.setState({
        isStepOne: false,
        isStepTwo: false,
        isStepThree: false,
        isStepFour: false,
        activeTab: key
      });
    } else if (key === "two") {

      if (this.state.isStepTwo) {
        return;
      }

      this.setState({
        isStepOne: true,
        isStepTwo: false,
        isStepThree: false,
        isStepFour: false,
        activeTab: key
      });
    } else if (key === "three") {
      if (this.state.isStepThree) {
        return;
      }

      this.setState({
        isStepOne: true,
        isStepTwo: true,
        isStepThree: false,
        isStepFour: false,
        activeTab: key
      });
    }
    else if (key === "four") {

      if (this.state.isStepFour) {
        return;
      }

      this.setState({
        isStepOne: true,
        isStepTwo: true,
        isStepThree: true,
        isStepFour: false,
        activeTab: key
      });
    }
  }

  genDummyTeams(numTeams, numGroup) {
    const groups = []
    const leters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    for (let i = 0; i < numGroup; i++) {
      let group = {
        id: this.makeid(i + numGroup),
        tmpID: this.makeid(i + numGroup),
        name: "Group " + leters[i],
        teams: []
      }

      for (let x = 0; x < numTeams; x++) {
        let team = {
          id: this.makeid(x + (numTeams - numGroup)),
          tmpID: this.makeid(x + (numTeams - numGroup))
        }

        group.teams.push(team)
      }

      groups.push(group)
    }

    this.state.league.groups = groups
    this.setState({
      league: this.state.league
    });

    const _that = this
    const dataTo = {
      league: this.state.league,
      user: FakeData.getData("yoo")
    }

    FakeData.post("/createSeason.php?auth0", dataTo, {
      success: ((res) => {
        _that.state.league.tempSeason = res.data
        _that.state.league.groups = res.data.groups
        if (res.status) {
          _that.setState({
            league: _that.state.league
          });
          _that.setStep("three")
        }
      }),
      error: ((err) => {
        //console.log(err);
      })
    }, true, "", null)
  }

  onTeamSelect(team, teamId, groupId) {
    const l = this.state.league.groups
    const _that = this
    l.forEach((group, i) => {
      if (group.teams.indexOf(team) > -1) {
        const index = group.teams.indexOf(team)
        _that.state.league.groups[i].teams[index].isError = true
        _that.setState({
          league: _that.state.league
        });
        return false;
      } else if (group.id === groupId) {
        group.teams.forEach((item, x) => {
          if (item.id === teamId) {
            const dataTo = {
              leagueId: _that.state.league.id,
              seasonId: _that.state.league.tempSeason.id,
              groupId: group.tmpID,
              teamTmpId: item.tmpID,
              teamId: team.id,
              squadId:team.squadId
            }

            console.log(item,team,teamId)

            FakeData.post("/addSeasonTeam.php?auth0", dataTo, {
              success: ((res) => {
                if (res.status) {
                  _that.state.league.groups[i].teams[x] = team
                  _that.setState({
                    league: _that.state.league
                  });
                  console.log(res)
                }
              }),
              error: ((err) => {
                //console.log(err);
              })
            }, true, team.name+" was added!", ((data) => {

            }))
          }

          _that.state.league.groups[i].teams[x].isError = false
          _that.setState({
            league: _that.state.league
          });
        })
      }
    })
  }

  validateStepThree() {
    this.props.onSaveSeason()
  }

  validateStepFour() {
    const st = this.state
    const lg = this.state.league
    const _that = this
    if ((st.contactMainError) || (st.ceoError) || (st.userError) || (st.contactOtherError) || (st.emailError) || (st.webError) || (st.cityError) || (st.countryError)
      || (st.postalError) || (st.addressError) || (st.aboutError)) {
      return
    }

    const dataTo = {
      user: this.state.user,
      league: this.state.league
    }

    FakeData.post('/createLeague.php?auth0', dataTo, {
      success: ((res) => {
        _that.state.league.id = res.id
        _that.setState({
          league: _that.state.league
        });
      }),
      error: ((err) => {

      })
    }, true, "", null)
  }

  render() {
    if (this.state.league.id !== null && !this.props.isSeason) {
      return (
        <div className="CreateLeague" style={{ margin: ((this.props.isSeason) ? "0%" : "10% 0%"), padding: ((this.props.isSeason) ? "0px" : "30px"), width: ((this.props.isSeason) ? "100%" : "70%") }}>
          <p className="league-after-save">Your page was successfully created, click <Link  to={"/league/" + this.state.league.id}>here</Link> to modify it further or <Link  to="/">Go Home</Link></p>
        </div>
      )
    }
    return (
      <div className="CreateLeague" style={{ margin: ((this.props.isSeason) ? "0%" : "10% 0%"), padding: ((this.props.isSeason && !this.props.isManage) ? "0px" : "30px"), width: ((this.props.isSeason) ? "100%" : "70%") }}>
        <div className="CreateLeague-Steps">
          {!this.props.isSeason &&
            <div className={(this.state.isStepOne) ? "done" : ((this.state.activeTab === "one") ? "active" : "")}><span>Step 1</span></div>
          }
          {(this.props.isSeason && !this.props.isManage) &&
            <div className={(this.state.isStepTwo) ? "done" : ((this.state.activeTab === "two") ? "active" : "")}><span>Step 1</span></div>
          }
          {(this.props.isSeason && !this.props.isManage) &&
            <div className={(this.state.isStepThree) ? "done" : ((this.state.activeTab === "three") ? "active" : "")}><span>Step 2</span></div>
          }
          {!this.props.isSeason &&
            <div className={(this.state.isStepFour) ? "done" : ((this.state.activeTab === "four") ? "active" : "")}><span>Step 2</span></div>
          }
        </div>
        <div className="CreateLeague-Forms">
          {(this.state.activeTab === "one") &&
            <div className="CreateLeague-Form">
              <InputField value={this.state.league.name} error={this.state.nameError} label="Competion Name" type="text" onChange={(e) => {
                this.state.league.name = e.target.value
                this.setState({
                  league: this.state.league,
                  nameError: false
                });
              }} />
              <SelectField data={this.state.types} error={this.state.typeError} value={this.state.activeState} label="Competion Type" onChange={(e) => {
                this.state.league.type = e.target.value
                this.setState({
                  league: this.state.league,
                  activeState: e.target.value,
                  typeError: false
                });
              }} />

              <SelectField data={this.state.sports} error={this.state.sportError} value={this.state.activeState} label="Competion Sport" onChange={(e) => {
                this.state.league.sport = e.target.value
                this.setState({
                  league: this.state.league,
                  activeState: e.target.value,
                  sportError: false
                });
              }} />

              <button onClick={() => this.validateStepOne()}>Next</button>
            </div>
          }

          {(this.state.activeTab === "two") &&
            <div className="CreateLeague-Form">
              {(this.state.league.type === "group_knockout") &&
                <InputField value={this.state.league.name} error={this.state.noOfGroupsError} label="No. of Groups" type="number" onChange={(e) => {
                  this.state.league.noOfGroups = e.target.value
                  if (e.target.value <= 0 || (e.target.value % 4) !== 0) {
                    this.setState({
                      league: this.state.league,
                      noOfGroupsError: true
                    });
                  } else {
                    this.setState({
                      league: this.state.league,
                      noOfGroupsError: false
                    });
                  }
                }} />
              }

              {(this.state.league.type !== "group_knockout") &&
                <InputField value={this.state.league.name} error={this.state.noOfTeamsError} label={"No. of Teams" + ((this.state.league.type === "knockout") ? " (8 or 16)" : "")} type="number" onChange={(e) => {
                  this.state.league.noOfTeams = e.target.value
                  if (e.target.value <= 0) {
                    this.setState({
                      league: this.state.league,
                      noOfTeamsError: true
                    });
                  } else if ((this.state.league.type === "knockout") && (e.target.value > 16)) {
                    this.setState({
                      league: this.state.league,
                      noOfTeamsError: true
                    });
                  } else if ((this.state.league.type === "knockout") && (e.target.value % 2 !== 0)) {
                    this.setState({
                      league: this.state.league,
                      noOfTeamsError: true
                    });
                  } else {
                    this.setState({
                      league: this.state.league,
                      noOfTeamsError: false
                    });
                  }
                }} />
              }
              {(this.state.league.type === "group_knockout") &&
                <InputField value={this.state.league.name} error={this.state.noOfTeamsGroupError} label="No. of Teams Per Group" type="number" onChange={(e) => {
                  this.state.league.noOfTeamsGroup = e.target.value
                  if (e.target.value <= 1) {
                    this.setState({
                      league: this.state.league,
                      noOfTeamsGroupError: true
                    });
                  } else {
                    this.setState({
                      league: this.state.league,
                      noOfTeamsGroupError: false
                    });
                  }
                }} />
              }
              <InputField value={this.state.league.name} error={this.state.noOfLegsError} label="No. of Legs" type="number" onChange={(e) => {
                this.state.league.noOfLegs = e.target.value
                if (e.target.value <= 0) {
                  this.setState({
                    league: this.state.league,
                    noOfLegsError: true
                  });
                } else {
                  this.setState({
                    league: this.state.league,
                    noOfLegsError: false
                  });
                }
              }} />
              <button onClick={() => this.validateStepTwo()}>Next</button>
            </div>
          }

          {(this.state.activeTab === "three") &&
            <div className="CreateLeague-Form">
              <TeamSelections league={this.state.league} onTeamSelect={this.onTeamSelect} />
              <button onClick={() => this.validateStepThree()} style={{ width: "100%" }}>Save</button>
            </div>
          }

          {(this.state.activeTab === "four") &&
            <div className="CreateLeague-Form">
              <br />
              <ItemPicker isExtended="true" user={this.state.user} error={this.state.ceoError} onSelectedItem={(item) => {
                this.state.league.ceo = item
                this.setState({
                  league: this.state.league,
                  ceoError: false
                });
              }} path="./" label="CEO" data={this.state.user.friends} />
              <ItemPicker isExtended="true" user={this.state.user} error={this.state.userError} onSelectedItem={(item) => {
                this.state.league.secretary = item
                this.setState({
                  league: this.state.league,
                  userError: false
                });
              }} path="./" label="Secretary" data={this.state.user.friends} />
              <InputFieldSm value="" error={this.state.contactMainError} label="Contact Number" type="number" onChange={(e) => {
                this.state.league.contactMain = e.target.value
                if (e.target.value.length < 10) {
                  this.setState({
                    league: this.state.league,
                    contactMainError: true
                  });
                } else {
                  this.setState({
                    league: this.state.league,
                    contactMainError: false
                  });
                }
              }} />
              <InputFieldSm value="" error={this.state.contactOtherError} label="Alternative Number" type="number" onChange={(e) => {
                this.state.league.contactOther = e.target.value
                if (e.target.value.length < 10) {
                  this.setState({
                    league: this.state.league,
                    contactOtherError: true
                  });
                } else {
                  this.setState({
                    league: this.state.league,
                    contactOtherError: false
                  });
                }
              }} />
              <InputFieldSm value="" error={this.state.emailError} label="Email" type="email" onChange={(e) => {
                this.state.league.email = e.target.value
                let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(e.target.value)) {
                  this.setState({
                    league: this.state.league,
                    emailError: true
                  });
                } else {
                  this.setState({
                    league: this.state.league,
                    emailError: false
                  });
                }
              }} />
              <InputFieldSm value="" error={this.state.webError} label="Website" type="website" onChange={(e) => {
                this.state.league.website = e.target.value
                let re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                if (!re.test(e.target.value)) {
                  this.setState({
                    league: this.state.league,
                    webError: true
                  });
                } else {
                  this.setState({
                    league: this.state.league,
                    webError: false
                  });
                }
              }} />
              <InputFieldSm value="" error={this.state.dateError} label="Date Established" type="date" onChange={(e) => {
                this.state.league.date = e.target.value
                this.setState({
                  league: this.state.league,
                  dateError: false
                });
              }} />
              <InputFieldSm value="" error={this.state.addressError} label="Street Address" type="text" onChange={(e) => {
                this.state.league.address = e.target.value
                this.setState({
                  league: this.state.league,
                  addressError: false
                });
              }} />
              <InputFieldSm value="" error={this.state.suburbError} label="Suburb" type="text" onChange={(e) => {
                this.state.league.suburb = e.target.value
                this.setState({
                  league: this.state.league,
                  suburbError: false
                });
              }} />
              <InputFieldSm value="" error={this.state.cityError} label="City" type="text" onChange={(e) => {
                this.state.league.city = e.target.value
                this.setState({
                  league: this.state.league,
                  cityError: false
                });
              }} />
              <InputFieldSm value="" error={this.state.postalError} label="Postal Code" type="number" onChange={(e) => {
                this.state.league.postal = e.target.value
                this.setState({
                  league: this.state.league,
                  postalError: false
                });
              }} />
              <div className="CreateLeague-Form-Input">
                <h5>Country</h5>
                <CountryDropdown classes={(this.state.countryError) ? "error" : ""}
                  value={this.state.league.country}
                  onChange={(val) => {
                    this.state.league.country = val
                    this.setState({
                      league: this.state.league,
                      countryError: false
                    });
                  }} />
              </div>
              <TextFieldSm value="" error={this.state.aboutError} label="About" onChange={(e) => {
                this.state.league.about = e.target.value
                this.setState({
                  league: this.state.league,
                  aboutError: false
                });
              }} />
              <button onClick={() => this.validateStepFour()} style={{ width: "100%" }}>Save</button>
            </div>
          }
        </div>
      </div>
    )
  }
}

class InputField extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="CreateLeague-Form-Input">
        <h2>{this.props.label}</h2>
        <input className={(this.props.error) ? "error" : ""} type={this.props.type} onChange={(e) => this.props.onChange(e)} />
      </div>
    );
  }
}

class InputFieldSm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="CreateLeague-Form-Input">
        <h5>{this.props.label}</h5>
        <input style={{ width: "100%" }} className={(this.props.error) ? "error" : ""} type={this.props.type} onChange={(e) => this.props.onChange(e)} />
      </div>
    );
  }
}

class PickerFieldSm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="CreateLeague-Form-Input">
        <h5>{this.props.label}</h5>
        <input style={{ width: "95%" }} className={(this.props.error) ? "error" : ""} type={this.props.type} onChange={(e) => this.props.onChange(e)} />
      </div>
    );
  }
}

class TextFieldSm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="CreateLeague-Form-Input">
        <h5>{this.props.label}</h5>
        <textarea style={{ width: "100%", resize: "none", height: "150px" }} className={(this.props.error) ? "error" : ""} onChange={(e) => this.props.onChange(e)} />
      </div>
    );
  }
}

class SelectField extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="CreateLeague-Form-Input">
        <h2>{this.props.label}</h2>
        <select className={(this.props.error) ? "error" : ""} onChange={(e) => this.props.onChange(e)}>
          {
            this.props.data.map((item, i) =>
              <option key={i} value={item}>{item}</option>
            )
          }
        </select>
      </div>
    );
  }
}

class TeamSelections extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const groups = this.props.league.groups
    return (
      <div className="team-selections">
        <h2>Select Teams</h2>
        {
          groups.map((group, i) =>
            <TeamSelection key={i} group={group} onTeamSelect={this.props.onTeamSelect} />
          )
        }
      </div>
    );
  }
}

class TeamSelection extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const teams = this.props.group.teams
    return (
      <div className="team-selection">
        <h4 style={{ padding: "0px 15px" }}>{this.props.group.name}</h4>
        <div className="this-teams">
          {
            teams.map((team, i) =>
              <TeamPicker team={team} group={this.props.group} key={i} onTeamSelect={this.props.onTeamSelect} />
            )
          }
        </div>
      </div>
    );
  }
}

export class TeamPicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      value: "",
      teams: (FakeData.getData("all_teams")) ? FakeData.getData("all_teams") : [],
      filteredData: (FakeData.getData("all_teams")) ? FakeData.getData("all_teams") : [],
      isAddingNew: false,
      userTo: null,
      userError: false,
      emailTo: "",
      emailError: false,
      teamName: "",
      teamError: false
    }

    this.selectTeam = this.selectTeam.bind(this)
    this.addTeam = this.addTeam.bind(this)
    this.setUserToInvite = this.setUserToInvite.bind(this)
    this.emailChange = this.emailChange.bind(this)
    this.nameChange = this.nameChange.bind(this)
  }

  handleKeyup(e) {
    const val = e.target.value
    const newList = []
    this.state.teams.forEach((item) => {
      if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
        newList.push(item)
      }
    })

    this.setState({
      value: val,
      filteredData: newList
    })
  }

  onClose() {
    this.setState({
      isModalOpen: false
    });
  }

  selectTeam(team) {
    this.onClose()
    if (this.props.group) {
      this.props.onTeamSelect(team, this.props.team.id, this.props.group.id)
    } else {
      this.props.onTeamSelect(team)
    }
  }

  setUserToInvite(user) {
    this.setState({
      userTo: user,
      userError: false
    });
  }

  emailChange(e) {
    const val = e.target.value
    if ((val.indexOf("@") <= -1) || (val.indexOf(".") <= -1)) {
      this.setState({
        emailError: true,
        emailTo: val
      });
    } else {
      this.setState({
        emailError: false,
        emailTo: val
      });
    }
  }

  nameChange(e) {
    this.setState({
      teamName: e.target.value,
      teamError: false
    });
  }

  addTeam() {
    if ((this.state.teamName === "") || (this.state.teamName === null)) {
      this.setState({
        teamError: true
      });

      return
    }

    if ((this.state.emailTo === "") || (this.state.emailTo === null)) {
      this.setState({
        emailError: true
      });

      return
    }

    if (this.state.userTo === null) {
      this.setState({
        userError: true
      });

      return
    }

    const dataTo = {
      user: this.props.user,
      userTo: this.state.userTo,
      teamName: this.state.teamName,
      emailTo: this.state.emailTo
    }

    const _that = this

    FakeData.post('/registerGhostTeam.php?auth0', dataTo, {
      success: ((data) => {
        _that.selectTeam(data)
        _that.setState({
          isModalOpen: false
        });
      }),
      error: ((err) => {

      }, true, "", null)
    })
  }

  render() {
    return (
      <div className={(this.props.team.isError) ? "team-selected error" : "team-selected"}>
        <span onClick={() => this.setState({ isModalOpen: true })} style={{ display: "block", height: "100%", width: "100%", cursor: "pointer" }}>{(!this.props.team.name) ? "Select A Team" : this.props.team.name}</span>
        <Modal isOpen={this.state.isModalOpen} onClose={() => this.setState({ isModalOpen: false })}>
          <div className="add-team">
            <h1>Pick A Team</h1>
            <button className="button" onClick={() => this.setState({
              isAddingNew: true
            })}>Add Team</button>
            <div>
              <input onKeyUp={(e) => this.handleKeyup(e)} style={{ padding: "0em 0.5em", width: "100%", margin: "0px 0px 10px" }} placeholder="Enter a team name" />
              <div style={{ maxHeight: "300px", padding: "0px 0px 20px 0px", overflowY: "auto" }}>
                {
                  this.state.filteredData.map((item, i) =>
                    <div className="add-team-item" key={i} onClick={() => this.selectTeam(item)}>
                      <img src={item.image} />
                      <span>{item.name}</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.isAddingNew} onClose={() => this.setState({
            isAddingNew: false
          })}>
            <div className="add-a-team">
              <h1>Add A Team</h1>
              <div className="input-field">
                <span>Team Name</span>
                <input value={this.state.teamName} style={{ padding: "0px 0.2em" }} onChange={this.nameChange} className={(this.state.teamError) ? 'error' : ''} />
              </div>
              <div className="input-field">
                <ItemPicker isExtended="true" user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={this.setUserToInvite} width="27.85em" label="Name" data={FakeData.getData("yoo").friends} />
              </div>
              <div className="input-field">
                <span>Validation Email</span>
                <input value={this.state.emailTo} onChange={this.emailChange} style={{ padding: "0px 0.2em" }} className={(this.state.emailError) ? 'error' : ''} />
              </div>
              <button onClick={this.addTeam}>Add</button>
            </div>
          </Modal>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CreatePages/TOURNS.js